import AppProviders from './app/providers/AppProviders'

function App() {
  return <AppProviders />
}

export default App
